import { styled, Box } from "@mui/system";

export const Divider = styled("div")`
  height: 1px;
  background-color: rgba(230, 230, 230, 0.5);
  margin: 30px 0 20px;
`;

export const CompanyFieldWrapper = styled("div")`
  position: relative;
`;

export const QuestionIcon = styled("div")`
  position: absolute;
  top: 21px;
  left: 245px;
`;

export const IconSize = styled("div")`
  width: 24px;
  height: 24px;
`;

export const TextGrid = styled("div")`
  margin: auto;
`;

export const RadioButtonRoot = styled("div")`
  width: calc(33.33% - 20px);
  padding: 5px;
`;

export const ErrorMessage = styled("div")`
  color: #ea2b1e;
  line-height: 1;
  font-size: 12px;
  padding: 5px 45px;
`;

/**
 * Container with special ordering for mobile devices
 */
export const AnotherCitizenshipContainer = styled(Box)(({ theme }) => ({
  [`@media (max-width: ${theme.breakpoints.values.xs}px)`]: {
    order: 1
  }
}));

/**
 * Container that removes bottom margin from first child div
 */
export const MarginB0 = styled(Box)({
  "& > div:first-of-type": {
    marginBottom: "0px !important"
  }
});
